"use client";
import Script from "next/script";
import React from "react";

const CdpSdk = () => {
  const scriptSrc = process.env.NEXT_PUBLIC_CDP;

  if (!scriptSrc) {
    return null;
  }

  return (
    <Script
      id="tru-web-sdk-cdn-js"
      src={scriptSrc}
      async={true}
      strategy="afterInteractive"
    />
  );
};

export default CdpSdk;
